// Tile server configuration utility
export const getTileServerUrl = (): string => {
  // If environment variable is set, use it (Vite uses VITE_ prefix)
  if (typeof process !== 'undefined' && process.env?.VITE_TILESERVER_URL) {
    return process.env.VITE_TILESERVER_URL;
  }
  
  // Auto-detect environment based on hostname
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Local development - use HTTP with port
    return "http://35.222.60.146:8080";
  }
  // Production fallback when VITE_TILESERVER_URL was not set at build time.
  // Prefer setting VITE_TILESERVER_URL in .env and rebuilding so the correct URL is baked in.
  return "https://tiles.gpmapper.com";
};

export const getTileUrl = (countyKey: string): string => {
  const baseUrl = getTileServerUrl();
  return `${baseUrl}/data/${countyKey}/{z}/{x}/{y}.pbf`;
}; 
